import { CircularProgress } from '@mui/material';
import React from 'react';
import styled, { css } from 'styled-components';
import { BLACK2, WHITE } from '../theme';
import { MemberPanel } from './MemberPanel';

const LoadingPanelContainer = styled(MemberPanel)<{
  $noBorder?: boolean;
  $height?: number;
  $fullHeight?: boolean;
  $backgroundColor?: string;
  $overlay?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  ${({ $backgroundColor }) =>
    $backgroundColor ? `background-color: ${$backgroundColor}` : ''};
  ${({ $height }) => ($height ? `min-height: ${$height}px` : '')};
  ${({ $fullHeight }) => ($fullHeight ? `height: 100%` : '')};
  ${({ $noBorder }) => ($noBorder ? `border: none` : '')};

  ${({ $overlay }) =>
    $overlay
      ? css`
        position: absolute;
        pointer-events: none;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${WHITE}66;
        z-index: 5;
      `
      : ''}
`;

type LoadingPanelProps = {
  height?: number;
  fullHeight?: boolean;
  noBorder?: boolean;
  testId?: string;
  backgroundColor?: string;
  overlay?: boolean;
  iconColor?: string;
};

/**
 * @TODO
 * This component should be decoupled from the MemberPanel component.
 * It should only contain a spinner, height prop, and nothing else.
 * This component should take full width and center the spinner.
 */
const LoadingPanel: React.FC<LoadingPanelProps> = ({
  height = 100,
  fullHeight = false,
  noBorder,
  testId,
  backgroundColor,
  iconColor = BLACK2,
  overlay,
}) => (
  <LoadingPanelContainer
    $height={height}
    $fullHeight={fullHeight}
    $noBorder={noBorder}
    testId={testId}
    $backgroundColor={backgroundColor}
    $overlay={overlay}
  >
    <CircularProgress
      size={Math.min(20, height)}
      style={{ color: iconColor }}
      data-testid={testId ? `${testId}-loadingPanel` : `loadingPanel`}
    />
  </LoadingPanelContainer>
);

export default LoadingPanel;
